/**
 * La Cucina di Cló — calm reveal on scroll
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const nodes = document.querySelectorAll('.lc-reveal');
  if (!nodes.length || !('IntersectionObserver' in window)) {
    nodes.forEach(function (el) {
      el.classList.add('is-inview');
    });
    return;
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  nodes.forEach(function (el) {
    observer.observe(el);
  });
})();
